module.exports = __webpack_public_path__ + "media/status-warning.4c347803.svg";